import { getApiClient } from "src/utils/axios";
import { paths } from "@classdojo/ts-api-types";

type ApiResponse =
  paths["/api/uploadFileURL"]["get"]["responses"][200]["content"]["application/json"];

export const getUploadURL = async (type: string, filename?: string) => {
  const filenameEx = filename ? encodeURIComponent(filename) : undefined;

  const { data } = await getApiClient().get<ApiResponse>("/api/uploadFileURL", {
    params: filenameEx ? { type, filename: filenameEx } : { type },
  });

  return {
    uploadUrl: data._links?.url?.href,
    destinationUrl: data.path,
  };
};
